import { gql } from '@apollo/client';

export const RUN_FIX_MISSING_S3_OBJECT_KEYS_ON_REPORT_ATTACHMENTS = gql`
  mutation($input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput!) {
    runFixMissingS3ObjectKeysOnReportAttachment(input: $input) {
      clientMutationId
    }
  }
`;